import classNames from 'classnames'
import { useEffect, useMemo } from 'react'
import { createPortal } from 'react-dom'

import { CenteredBlock, Icon } from '@/shared'
import { EIcons } from '@App/types/iconType'

import style from './Modal.module.scss'

const modalRootElement = document.querySelector('#popap_window')

export const Modal: React.FC<{
    show: boolean
    modalStyles?: string
    children: React.ReactNode
    onClose?: () => void
    withScrollToTopAfterClose?: boolean
}> = (props) => {
    const { children, show, onClose, withScrollToTopAfterClose, modalStyles } = props

    const element = useMemo(() => document.createElement('div'), [])

    useEffect(() => {
        if (show) {
            modalRootElement?.appendChild(element)
            return () => {
                modalRootElement?.removeChild(element)
            }
        }
    }, [show, element])

    const onCloseBtn = () => {
        withScrollToTopAfterClose && window.scrollTo(0, 0)
        if (onClose) {
            onClose()
        }
    }

    useEffect(() => {
        if (show) {
            document.body.style.overflow = 'hidden'
        }
        return () => {
            document.body.style.overflow = 'unset'
        }
    }, [show])

    return createPortal(
        <CenteredBlock className={style.container}>
            <div className={classNames(style.modalWrapper, modalStyles)}>
                {onClose && (
                    <CenteredBlock className={style.closeBtn} onClick={onCloseBtn}>
                        <Icon iconName={EIcons.CLOS} />
                    </CenteredBlock>
                )}
                {children}
            </div>
        </CenteredBlock>,
        element
    )
}
